var _circle, _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDriverPin(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#757A93"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1263_2584)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 11.25C18.4625 11.25 19.25 12.0375 19.25 13C19.25 13.9625 18.4625 14.75 17.5 14.75C16.5375 14.75 15.75 13.9625 15.75 13C15.75 12.0375 16.5375 11.25 17.5 11.25ZM17.5 20C19.8625 20 22.575 21.1287 22.75 21.75H12.25C12.4512 21.12 15.1462 20 17.5 20ZM17.5 9.5C15.5662 9.5 14 11.0662 14 13C14 14.9338 15.5662 16.5 17.5 16.5C19.4338 16.5 21 14.9338 21 13C21 11.0662 19.4338 9.5 17.5 9.5ZM17.5 18.25C15.1637 18.25 10.5 19.4225 10.5 21.75V23.5H24.5V21.75C24.5 19.4225 19.8363 18.25 17.5 18.25Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1263_2584"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    transform: "translate(7 6)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriverPin);
export default __webpack_public_path__ + "static/media/driver-pin.6e4c038dbbc452b353c76d4da184b2bf.svg";
export { ForwardRef as ReactComponent };